<template>
  <div class="location-list">
    <!-- Komunikaty -->
    <div v-if="message" :class="['alert', messageType === 'error' ? 'alert-danger' : 'alert-success']" role="alert">
      {{ message }}
    </div>

    <table class="table table-striped align-middle" v-if="!loading">
      <thead class="thead-light">
        <tr>
          <th style="width: 6%">{{ t('location-id') }}</th>
          <th>{{ t('location-name') }}</th>
          <th style="width: 12%">{{ t('location-short-name') }}</th>
          <th style="width: 10%">{{ t('road-number') }}</th>
          <th style="width: 8%">{{ t('direction') }}</th>
          <th style="width: 8%">{{ t('lanes') }}</th>
          <th style="width: 18%">{{ t('action') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="location in locations" :key="location.id">
          <td>{{ location.id }}</td>
          <td>{{ location.name }}</td>
          <td>{{ location.shortName }}</td>
          <td>{{ location.roadNumber }}</td>
          <td>{{ location.direction }}</td>
          <td>{{ location.lanes ? location.lanes.length : 0 }}</td>
          <td>
            <button type="button" class="btn button-edit button-compact" @click="$emit('edit', location.id)">
              {{ t('edit') }}
            </button>
            <!-- Usuwanie z potwierdzeniem inline -->
            <template v-if="pendingDeleteId === location.id">
              <button type="button" class="btn button-delete button-compact" @click="confirmDelete(location.id)">
                {{ t('confirm-delete') }}
              </button>
              <button type="button" class="btn button-add-user button-compact" @click="pendingDeleteId = null">
                {{ t('cancel') }}
              </button>
            </template>
            <button
              v-else
              type="button"
              class="btn button-delete button-compact"
              @click="pendingDeleteId = location.id"
            >
              {{ t('delete') }}
            </button>
          </td>
        </tr>
        <tr v-if="!locations.length">
          <td colspan="7" class="text-center text-muted">{{ t('locations-empty') }}</td>
        </tr>
      </tbody>
    </table>

    <div v-else class="text-center text-muted py-3">{{ t('loading') }}</div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import LocationsService from "@/services/LocationsService";

const { t } = useI18n();
defineEmits(["edit"]);

const locations = ref([]);
const loading = ref(false);
const pendingDeleteId = ref(null);
const message = ref("");
const messageType = ref("success");

async function load() {
  loading.value = true;
  message.value = "";
  try {
    const res = await LocationsService.getLocationList(1, 1000);
    // getWithCount zwraca { totalCount, content }; bez licznika — zwykłą tablicę.
    locations.value = Array.isArray(res) ? res : (res?.content ?? []);
  } catch (error) {
    messageType.value = "error";
    message.value = typeof error === "string" ? error : t("locations-load-error");
    locations.value = [];
  } finally {
    loading.value = false;
  }
}

async function confirmDelete(id) {
  message.value = "";
  try {
    await LocationsService.deleteLocation(id);
    pendingDeleteId.value = null;
    messageType.value = "success";
    message.value = t("location-deleted");
    await load();
  } catch (error) {
    pendingDeleteId.value = null;
    messageType.value = "error";
    // Backend zwraca 409, gdy istnieją powiązane pomiary.
    message.value = typeof error === "string" ? error : t("location-delete-blocked");
  }
}

// Udostępnij reload rodzicowi (przez ref na komponencie).
defineExpose({ load });

onMounted(load);
</script>

<style scoped>
.location-list {
  background-color: white;
}

/* Spójne zaokrąglenie przycisków (radius: 4px) jak w reszcie projektu. */
.location-list .btn {
  border-radius: 4px !important;
}

.button-compact {
  padding: 0.5rem 1rem;
  margin-right: 0.35rem;
}
</style>
